import { colleges } from "api/certified-api";

/**
 * Genera los encabezados comunes para las peticiones.
 * @param {string} token - Token JWT.
 * @returns {Object} Headers estándar.
 */
const getHeaders = (token) => ({
	'Content-Type': 'application/json',
	'Accept': 'application/json',
	'x-access-token': token
});

/**
 * Obtiene colegios filtrados mediante query params.
 *
 * Permite obtener:
 * - Todos los colegios: {}
 * - Colegio por ID: { id: 66 }
 * - Colegio por name: { name: 'Colegio D' }
 *
 * @param {Object} filters - Objeto con filtros como id, name, etc.
 * @param {string} token - Token JWT.
 * @returns {Promise<Object>} Datos de los colegios.
 */
export const fetchColleges = async (filters = {}, token) => {
	const query = new URLSearchParams(filters).toString();
	const url = query ? `/?${query}` : `/`;

	const response = await colleges.get(url, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Crea un nuevo colegio en la base de datos.
 * @param {Object} data - Datos del colegio a crear.
 * @param {string} token - Token de autenticación.
 * @returns {Promise<Object>} Respuesta de la API con el colegio creado.
 */
export const createCollege = async (data, token) => {
	const response = await colleges.post(`/`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Actualiza los datos de un colegio existente.
 * @param {number|string} id - ID del colegio a actualizar.
 * @param {Object} data - Nuevos datos del colegio.
 * @param {string} token - Token de autenticación.
 * @returns {Promise<Object>} Colegio actualizado.
 */
export const updateCollegeById = async (id, data, token) => {
	const response = await colleges.put(`/${id}`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Elimina un colegio por su ID.
 * @param {number|string} id - ID del colegio a eliminar.
 * @param {string} token - Token de autenticación.
 * @returns {Promise<Object>} Respuesta de la API.
 */
export const deleteCollegeById = async (id, token) => {
	const response = await colleges.delete(`/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};